import React from 'react'
import { inject, observer } from 'mobx-react'
import { List, Select, Tag } from 'antd'

import logTypes from '../logTypes'

@inject((store: any) => {
    const { logsStore } = store
    return { logsStore }
})
@observer
export default class extends React.Component<any, any> {
    render() {
        const {
            list,
            loading,
            analyzedList,
            analyzeData,
            setAnalyzeBy,
            analyzeBy,
            addFilter,
            getLogsList
        } = this.props.logsStore
        const { selectedType } = this.props
        const displayFields = selectedType ? logTypes[selectedType].displayFields : null
        let dataSource = []
        Object.keys(analyzedList).map(key => dataSource.push({ ...analyzedList[key] }))
        return (
            <>
                {!!(list.length && selectedType && displayFields) && (
                    <Select
                        style={{ width: '100%' }}
                        placeholder="בחר ערך לניתוח הנתונים"
                        value={analyzeBy ? analyzeBy : undefined}
                        onChange={e => {
                            setAnalyzeBy(e)
                            analyzeData()
                        }}
                    >
                        {Object.keys(displayFields).map((key, index) => (
                            <Select.Option key={index} value={key}>
                                פילוח על פי {displayFields[key]}
                            </Select.Option>
                        ))}
                    </Select>
                )}
                <List
                    loading={loading}
                    dataSource={dataSource.sort((a, b) => b.count - a.count)}
                    renderItem={(item, index) => (
                        <List.Item key={index} style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                            <div>
                                <Tag>{item.count}</Tag> <strong>"{item.value}"</strong> ב-{logTypes[item.subType].title}
                            </div>
                        </List.Item>
                    )}
                    pagination={{ pageSize: 10 }}
                />
            </>
        )
    }
}
